import { Enum, Type } from '@sinclair/typebox';
import { ConditionOperators, ConditionRelations } from '@stickerapp-org/nomisma';
import { AttributeValueMultiSchema } from "./shared.mjs";
export const ConditionValueSchema = Type.Union([Type.Number(), Type.String(), Type.Boolean(), Type.Array(Type.String())]);
export const ConditionSchema = Type.Object({
    key: Type.String(),
    operator: Enum(ConditionOperators),
    value: ConditionValueSchema,
});
export const ConditionBuilderSchema = Type.Object({
    conditions: Type.Any(),
    baseComplexityScore: Type.Number(),
    relationMode: Enum(ConditionRelations),
});
export const RuleSchema = Type.Object({
    values: AttributeValueMultiSchema,
    conditionBuilder: ConditionBuilderSchema,
});
//# sourceMappingURL=condition.js.map